import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';

@Injectable()
export class InternalUrlResolver implements Resolve<void> {

  constructor() { }

  resolve(route: ActivatedRouteSnapshot): void {
    const eventId = route.queryParams['id'];
    window.location.href = eventId ? route.queryParams['internalUrl'] + '#/event?id=' + route.queryParams['id'] : route.queryParams['internalUrl'];
  }
}
